import { createSlice } from '@reduxjs/toolkit'
import { SecurityUsersServerData } from '@lk/api'

import { loadSecurityUsers } from './users.actions'

export interface SecurityUsersState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string | null
  list: SecurityUsersServerData
}

const initialState: SecurityUsersState = {
  status: 'idle',
  error: null,
  list: [],
}

export const securityUsersReducer = createSlice({
  name: 'securityUsers',
  initialState,
  reducers: {},
  extraReducers: {
    [loadSecurityUsers.pending.toString()]: (state) => {
      state.status = 'loading'
      state.list = []
    },
    [loadSecurityUsers.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.list = action.payload
    },
    [loadSecurityUsers.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
      state.list = []
    },
  },
}).reducer
